<template>
    <v-app class="white">
        <v-content>
            <v-form class="login hidden-sm-and-down">
                <v-container row>
                    <v-layout column>
                        <v-flex xs12 sm6>
                            <v-text-field required autocomplete="email" label="E-mail" v-model="email"></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6>
                            <v-text-field
                                    v-show="!resetPassword"
                                    required
                                    autocomplete="password"
                                    v-model="password"
                                    :append-icon="show ? 'visibility' : 'visibility_off'"
                                    :type="show ? 'text' : 'password'"
                                    label="Пароль"
                                    @click:append="show = !show">
                            </v-text-field>
                        </v-flex>
                        <v-flex class="text-end">
                            <v-btn
                                    text
                                    small
                                    flat
                                    v-show="!resetPassword"
                                    color="normal"
                                    class="ma-0 reset-password"
                                    @click="onResetPassword">Забыли пароль?</v-btn>
                        </v-flex>
                        <v-flex>
                            <v-btn dark color="normal" @click="onClick" v-text="buttonTitle"></v-btn>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-form>
            <v-form class="login_sm hidden-md-and-up">
                <v-container row>
                    <v-layout column>
                        <v-flex xs12 sm6>
                            <v-text-field required autocomplete="email" label="E-mail" v-model="email"></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6>
                            <v-text-field
                                    v-show="!resetPassword"
                                    required
                                    autocomplete="password"
                                    v-model="password"
                                    :append-icon="show ? 'visibility' : 'visibility_off'"
                                    :type="show ? 'text' : 'password'"
                                    label="Пароль"
                                    @click:append="show = !show">
                            </v-text-field>
                        </v-flex>
                        <v-flex class="text-end">
                            <v-btn
                                    text
                                    small
                                    v-show="!resetPassword"
                                    class="ma-0 reset-password"
                                    @click="onResetPassword">Забыли пароль?</v-btn>
                        </v-flex>
                        <v-flex text-xs-right>
                            <v-btn dark color="normal" @click="onClick" v-text="buttonTitle"></v-btn>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-form>
        </v-content>
    </v-app>
</template>


<script>
    import firebase from "firebase";

    export default {
        data() {
            return {
                email: "",
                password: "",
                show: false,
                resetPassword: false,
            };
        },
        computed: {
          buttonTitle : function() {
              return this.resetPassword ? 'Сменить пароль' : 'Войти'
          }
        },
        methods: {
            onClick: function () {
                if (this.resetPassword) {
                    firebase
                        .auth()
                        .sendPasswordResetEmail(this.email)
                        .then(
                            () => {
                                alert('Информация о сбросе пароля отправлена на ваш email');
                                this.resetPassword = false
                            },
                            err => alert(err.message)
                        )
                } else {
                    firebase
                        .auth()
                        .signInWithEmailAndPassword(this.email, this.password)
                        .then(
                            () => this.$router.push("/home"),
                            err => alert(err.message)
                        );
                }
            },
            onResetPassword: function () {
                this.resetPassword = true
            }
        }
    };
</script>

<style>
    .login {
        display: block;
        margin-bottom: auto;
        margin-left: auto;
        margin-right: auto;
        width: 30%;
    }
    .reset-password {
        height: 18px !important;
        font-size: 6pt !important;
    }
    .login_sm {
        display: block;
        margin-bottom: auto;
        margin-left: auto;
        margin-right: auto;
        width: 90%;
    }
</style>